import { pipe, intersperse, reject, isEmpty, join, map, split } from 'ramda';
import { chainCommands, exitCode } from 'prosemirror-commands';
import { Node, Fragment } from 'prosemirror-model';
import schema from './lineBreakSchema';

const linebreak = { type: 'hard_break' };
const textNode = (text: string) => ({ type: 'text', text });

// The \\n is legacy support
const splitRegex = /(?:\n|\\n)/;

/**
 * Convert a string with normal characters and \\n into a ProseMirror document.
 * Preserves consecutive linebreaks.
 */
const createNode = pipe(
  split(splitRegex),
  (strs: Array<string>) => map((token) => (token ? textNode(token) : ''), strs),
  (strs: Array<'' | typeof linebreak | ReturnType<typeof textNode>>) => intersperse(linebreak, strs),
  reject(isEmpty)
);

const serializeNode = (fragment: Fragment) => {
  const serialized = [];

  fragment.forEach((node) => {
    if (node.type.name === 'text') {
      serialized.push(node.text);
    } else if (node.type.name === 'hard_break') {
      serialized.push('\n');
    }
  });

  return serialized;
};

const nodeFromContent = (content: string) => ({
  type: 'doc',
  content: createNode(content),
});

const contentFromNode = (node: Node) => (node.content ? join('', serializeNode(node.content)) : '');

const br = schema.nodes.hard_break;
const cmd = chainCommands(exitCode, (state, dispatch) => {
  dispatch(state.tr.replaceSelectionWith(br.create()).scrollIntoView());

  return true;
});

const linebreakKeyMap = {
  Enter: cmd,
};

export { linebreakKeyMap, contentFromNode, nodeFromContent };
